import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
//import { FormControl, FormGroup, Validators } from '@angular/forms';
//import { GlobalConstants } from 'src/app/common/global-constants';
import { IssueModel } from '../models/issue.model';
import { UserService } from './user.service';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class IssueService {
  //readonly BaseURI = GlobalConstants.apiURL;
  BaseURI : string;
  readonly apiController = "/Issues";

    constructor(private http : HttpClient, private userservice : UserService) {
      console.log("constructor : ClientService ");
      this.BaseURI = window.location.origin + "/api";
    }
     getData(id)
     {
        return this.http.get(this.BaseURI + this.apiController + "/" + id);
     }

     getDetailData(id)
     {
        return this.http.get(this.BaseURI + this.apiController + "/IssueDetail?id=" + id);
     }

     getList()
     {
        return this.http.get(this.BaseURI + this.apiController);
      }

     getDetailList()
     {
        return this.http.get(this.BaseURI + this.apiController + "/IssueDetailList");
      }

     insertData(item : IssueModel) {

      item.createBy = this.userservice.getUserID();

       return this.http.post(this.BaseURI + this.apiController, _.omit(item, ["issueId", "ticketNo", "createTime"]));
     }

     updateData(item : IssueModel) {
       return this.http.put(this.BaseURI + this.apiController + "/" + item.issueId, item);
     }
     /*
     updateData(item : IssueWithFileModel) {
      return this.http.put(this.BaseURI + this.apiController + "/" + item.issueId, item);
    }*/

     deleteData(id)
     {
       return this.http.delete(this.BaseURI + this.apiController + "/" + id);

     }

     closeIssue(item : IssueModel) {
      item.closeBy = this.userservice.getUserID();
      return this.http.put(this.BaseURI + this.apiController + "/CloseIssue?id=" + item.issueId, item);
    }

    reopenIssue(item : IssueModel) {
      return this.http.put(this.BaseURI + this.apiController + "/ReopenIssue?id=" + item.issueId, item);
    }

    findByCustomer(id)
    {
      return this.http.get(this.BaseURI + this.apiController + "/FindByCustomer?id=" + id);
    }



    getOpenedIssueList(count)
    {

      return this.http.get(this.BaseURI + this.apiController + "/OpenedIssueDetailList?count=" + count);
   }

   getIssueFileList(id)
    {

      return this.http.get(this.BaseURI + this.apiController + "/GetAttachedFileList?id=" + id);
   }
  }
